export const GOOTRANS_COOKIE = 'googtrans';
